import { gql } from '@apollo/client';

export const HANDLE_WHOLE_CASK_ISSUE = gql`
  mutation handleWholeCaskIssue($input: HandleWholeCaskIssueInput!) {
    handleWholeCaskIssue(input: $input) {
      _id
      status
      signature
      txHash
    }
  }
`;
